import EncryptedTransferInteraction from "@/models/EncryptedTransferInteraction";
import KeyUtility from "@/util/keyUtility";
import ByteEncoder from "@/util/byteEncoder";
import FileAES from "@/util/fileAES";
import Base64Encoder from "@/util/base64encoder";

export default class TransferInteraction {

  type!: 'approval' | 'comment' | 'download';
  data!: { name: string, approved: boolean } | { name: string, comment: string } | string;
  fileIdx!: number;
  created!: Date; //Exists in encrypted and in decrypted form


  public static fromString(json: string): TransferInteraction {
    const newInstance = new TransferInteraction();
    const restored = JSON.parse(json);
    return Object.assign(newInstance, restored);
  }

  public static APPROVAL(fileIdx: number, name: string, approved: boolean): TransferInteraction {
    const result = new TransferInteraction();
    result.type = 'approval';
    result.fileIdx = fileIdx;
    result.created = new Date();
    result.data = { name, approved };
    return result;
  }

  public static COMMENT(fileIdx: number, name: string, comment: string): TransferInteraction {
    const result = new TransferInteraction();
    result.created = new Date();
    result.type = 'comment';
    result.fileIdx = fileIdx;
    result.data = {name, comment};
    return result;
  }

  public static DOWNLOAD(fileIdx: number, name: string): TransferInteraction {
    const result = new TransferInteraction();
    result.type = 'download';
    result.fileIdx = fileIdx;
    result.created = new Date();
    result.data = name;
    return result;
  }

  async encryptWithSerializedKey(serializedKey: string): Promise<EncryptedTransferInteraction> {
    const key: CryptoKey = await KeyUtility.loadKeyFromBase64(serializedKey);
    return this.encryptWithKey(key);
  }

  async encryptWithKey(key: CryptoKey): Promise<EncryptedTransferInteraction> {
    const payload = JSON.stringify(this);
    const iv = KeyUtility.generateIV();
    const jsonBytes: Uint8Array = ByteEncoder.stringToBytes(payload);
    const aes: FileAES = new FileAES(key);
    const encrypted = await aes.encryptChunk(jsonBytes, iv);
    const encryptedString = Base64Encoder.bytesToString(new Uint8Array(encrypted));
    const result = new EncryptedTransferInteraction();
    result.data = encryptedString;
    result.kind = this.type;
    result.iv = Base64Encoder.bytesToString(iv);
    return result;
  }

  public static async FROM_ENCRYPTED(encrypted: EncryptedTransferInteraction, key: CryptoKey): Promise<TransferInteraction> {
    const iv = Base64Encoder.stringToBytes(encrypted.iv);
    const encryptedBytes = Base64Encoder.stringToBytes(encrypted.data);
    const aes: FileAES = new FileAES(key);
    const decryptedBytes = await aes.decryptChunk(encryptedBytes, iv);
    const decryptedJSON = ByteEncoder.bytesToString(new Uint8Array(decryptedBytes));
    return TransferInteraction.fromString(decryptedJSON);
  }
}
